import { motion } from 'framer-motion';
import ContactForm from './ContactForm';

export default function ContactUsPage() {
  return (
    <section className="bg-white text-gray-900 py-20 px-6 md:px-20">
      {/* Hero */}
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="text-center max-w-3xl mx-auto mb-16"
      >
        <h1 className="text-4xl md:text-5xl font-bold mb-4 text-schoolRed text-rl">Get in Touch</h1>
        <p className="text-lg text-gray-700">
          We'd love to hear from you! Whether you have a question, want to schedule a visit, or simply say hello—feel free to reach out.
        </p>
      </motion.div>

      {/* Contact Form */}
      <ContactForm />

      {/* Locate Us Section */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="my-20 flex flex-col md:flex-row gap-8 items-center justify-center max-w-6xl mx-auto"
      >
        {/* Map */}
        <div className="flex-1 min-w-[300px] rounded-2xl overflow-hidden shadow-lg">
          <iframe
            title="Contact Us"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.286844571058!2d78.44629477538838!3d17.493815399730018!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb91f64a2bf2cd%3A0xb2e784a74e4ece44!2sSpringdales%20The%20School!5e0!3m2!1sen!2sus!4v1745206529236!5m2!1sen!2sus"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        {/* Address Card */}
        <div className="bg-gray-50 p-8 rounded-2xl shadow-lg flex flex-col items-start max-w-md text-left">
          <h2 className="text-2xl font-bold mb-4 text-schoolBlue">Locate Us</h2>
          <p className="text-gray-700 mb-4">
            Springdales The School <br />
            5-169, Plot no. 76, road no. 1, Chandra Nagar, Balanagar, Hyderabad, Telangana 500054, India
          </p>
          <p className="text-gray-700 mb-6">
            Phone:  +91 9959921485, +91 9154847441<br />
            Email: <a href="mailto:springdalestheschool@gmail.com">springdalestheschool@gmail.com</a>
          </p>
          <a
            href="https://www.google.com/maps/place/Springdales+The+School/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-schoolRed text-white px-6 py-2 rounded-full font-semibold hover:bg-red-600 transition"
          >
            Open in Maps
          </a>
        </div>
      </motion.div>
    </section>
  );
}
